import { CP_AUTH_EXCLUDED_PATHS_SET, CP_AUTH_FULL_SCREEN_PATHS_SET } from '../constants/auth.constants'

export function isCPAuthRoutePath(path?: string): boolean {
  if (!path) return false
  return CP_AUTH_EXCLUDED_PATHS_SET.has(path) || CP_AUTH_FULL_SCREEN_PATHS_SET.has(path) || path.startsWith('/login/')
}
